"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrieNode = void 0;
const path_1 = require("./path");
class TrieNode {
    constructor(parent, key) {
        if (parent && typeof key === 'string') {
            this.path = (0, path_1.pushPath)(parent.path, key);
            this.parent = parent;
            this.key = key;
        }
        else {
            this.key = '';
            this.path = '';
        }
    }
    getNodeAt(path, createIfNotExist) {
        let head = this;
        const parts = (0, path_1.toPathParts)(path);
        for (let i = 0; i < parts.length; i++) {
            const key = parts[i];
            const next = head.children && head.children[key];
            if (next) {
                head = next;
                continue;
            }
            if (!createIfNotExist)
                return undefined;
            const newNext = new TrieNode(head, key);
            if (!head.children)
                head.children = { [key]: newNext };
            else
                head.children[key] = newNext;
            head = newNext;
        }
        return head;
    }
    getValueAt(path) {
        var _a;
        return (_a = this.getNodeAt(path)) === null || _a === void 0 ? void 0 : _a.value;
    }
    setValueAt(path, value) {
        this.getNodeAt(path, true).value = value;
    }
    deleteChild(key) {
        if (!this.children)
            return;
        delete this.children[key];
    }
    clearChildren() {
        if (!this.children)
            return;
        this.children = void 0;
    }
    setKey(newKey) {
        const { parent, key: oldKey } = this;
        if (!parent)
            return;
        const oldPrefixLen = this.path.length;
        const newPrefix = (0, path_1.pushPath)(parent.path, newKey);
        this.key = newKey;
        // path在下面处理
        delete parent.children[oldKey];
        parent.children[newKey] = this;
        const queue = [this];
        while (queue.length) {
            const item = queue.pop();
            item.path = newPrefix + item.path.slice(oldPrefixLen);
            if (item.children)
                queue.push(...Object.values(item.children));
        }
    }
    /**
     * iterate through this node (including self).
     *
     * nodes with higher depth are always visited than those with less depth
     */
    forEachDFS(visitor) {
        const { children } = this;
        if (children) {
            Object.values(children).forEach((child) => {
                child.forEachDFS(visitor);
            });
        }
        visitor(this);
    }
}
exports.TrieNode = TrieNode;
